import { useEffect } from "react";

const WIDGET_URL = "https://link.smallbusinessautomator.com/widget/booking/33boziqrVZBugLLt7koH";

export default function BookingWidget() {
  useEffect(() => {
    if (document.querySelector('script[src*="form_embed.js"]')) return;
    const s = document.createElement("script");
    s.src = "https://link.msgsndr.com/js/form_embed.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div className="glass-card p-3 sm:p-4" data-testid="booking-widget-card">
      <p className="px-3 pt-2 font-mono text-[10px] tracking-[0.3em] text-[#D9622B]">FREE 1:1 SESSION — PICK YOUR TIME</p>
      <iframe
        src={WIDGET_URL}
        title="Book your Boots-First VA Benefit Review"
        id="33boziqrVZBugLLt7koH_booking"
        data-testid="booking-widget-iframe"
        className="w-full mt-2 rounded"
        style={{ border: "none", overflow: "hidden", minHeight: "680px", background: "transparent" }}
        scrolling="no"
      />
      <p className="pb-2 text-center text-[10px] text-white/25">Free · No obligation · Educational review only</p>
    </div>
  );
}
